import {TranslationDictionary} from '@shopify/react-i18n';

import cs from './cs.json';
import da from './da.json';
import de from './de.json';
import en from './en.json';
import es from './es.json';
import fi from './fi.json';
import fr from './fr.json';
import it from './it.json';
import ja from './ja.json';
import ko from './ko.json';
import nb from './nb.json';
import nl from './nl.json';
import pl from './pl.json';
import pt_BR from './pt-BR.json';
import pt_PT from './pt-PT.json';
import sv from './sv.json';
import th from './th.json';
import tr from './tr.json';
import vi from './vi.json';
import zh_CN from './zh-CN.json';
import zh_TW from './zh-TW.json';

export const Translations: {[id: string]: TranslationDictionary} = {
  en,
  cs,
  da,
  de,
  es,
  fi,
  fr,
  it,
  ja,
  ko,
  nb,
  nl,
  pl,
  'pt-BR': pt_BR,
  'pt-PT': pt_PT,
  sv,
  th,
  tr,
  vi,
  'zh-CN': zh_CN,
  'zh-TW': zh_TW,
};
